import { render, staticRenderFns } from "./TicketActivity.vue?vue&type=template&id=8c997562&scoped=true"
import script from "./TicketActivity.vue?vue&type=script&lang=js"
export * from "./TicketActivity.vue?vue&type=script&lang=js"
import style0 from "./TicketActivity.vue?vue&type=style&index=0&id=8c997562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c997562",
  null
  
)

export default component.exports